(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gff-delivery-regions"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.gff-delivery-regions[data-section-id]').forEach(function (section) {
      section.querySelectorAll('[data-gff-map-open]').forEach(function (btn) {
        var id = btn.getAttribute('data-gff-map-open');
        var dialog = id ? document.getElementById(id) : null;
        if (!dialog || typeof dialog.showModal !== 'function') return;

        btn.addEventListener('click', function () {
          if (window.matchMedia('(max-width: 700px)').matches && !dialog.open) {
            dialog.showModal();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gff-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('.gff-nav-root');
    roots.forEach(function (root) {
      if (root.dataset.gffNavBound) return;
      root.dataset.gffNavBound = 'true';

      /* ── Sticky nav: announcement scrolls away, nav stays pinned ─ */
      var nav = root.querySelector('.gff-nav');
      var stickyTarget = root.previousElementSibling;
      if (
        stickyTarget &&
        !stickyTarget.classList.contains('gff-nav__announce') &&
        !stickyTarget.classList.contains('gff-nav__sticky-sentinel')
      ) {
        stickyTarget = null;
      }

      function syncHeaderHeight() {
        if (!nav) return;
        var navH = Math.round(nav.getBoundingClientRect().height);
        document.body.style.setProperty('--header-height', navH + 'px');
        var groupH = navH;
        if (stickyTarget && stickyTarget.classList.contains('gff-nav__announce')) {
          groupH += Math.round(stickyTarget.getBoundingClientRect().height);
        }
        document.body.style.setProperty('--header-group-height', groupH + 'px');
      }

      if (nav && stickyTarget && 'IntersectionObserver' in window) {
        var stuckObserver = new IntersectionObserver(function (entries) {
          nav.dataset.stuck = entries[0].isIntersecting ? 'false' : 'true';
        }, { threshold: 0 });
        stuckObserver.observe(stickyTarget);
      } else if (nav) {
        nav.dataset.stuck = 'false';
      }

      if (nav && 'ResizeObserver' in window) {
        new ResizeObserver(syncHeaderHeight).observe(root);
        new ResizeObserver(syncHeaderHeight).observe(nav);
        if (stickyTarget) new ResizeObserver(syncHeaderHeight).observe(stickyTarget);
      }
      syncHeaderHeight();

      /* ── Mega menu ──────────────────────────────────────────── */
      var items = root.querySelectorAll('[data-mega-item]');
      var closeTimer = null;

      function cancelClose() {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      }

      function scheduleClose() {
        if (closeTimer) return;
        closeTimer = setTimeout(function () {
          closeTimer = null;
          closeAll(null);
        }, 200);
      }

      function closeAll(except) {
        items.forEach(function (item) {
          if (item === except) return;
          var trig = item.querySelector('[data-mega-trigger]');
          var panel = item.querySelector('.gff-mega');
          if (trig) trig.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('data-open', 'false');
        });
      }

      function anyOpen() {
        return Array.prototype.some.call(items, isOpen);
      }

      function openItem(item) {
        cancelClose();
        closeAll(item);
        var trig = item.querySelector('[data-mega-trigger]');
        var panel = item.querySelector('.gff-mega');
        if (trig) trig.setAttribute('aria-expanded', 'true');
        if (panel) panel.setAttribute('data-open', 'true');
      }

      function closeItem(item) {
        var trig = item.querySelector('[data-mega-trigger]');
        var panel = item.querySelector('.gff-mega');
        if (trig) trig.setAttribute('aria-expanded', 'false');
        if (panel) panel.setAttribute('data-open', 'false');
      }

      function isOpen(item) {
        var trig = item.querySelector('[data-mega-trigger]');
        return trig && trig.getAttribute('aria-expanded') === 'true';
      }

      items.forEach(function (item) {
        var trig = item.querySelector('[data-mega-trigger]');
        if (!trig) return;

        item.addEventListener('pointerenter', function () {
          if (window.matchMedia('(max-width: 1279px)').matches) return;
          openItem(item);
        });
        item.addEventListener('focusin', function () {
          if (window.matchMedia('(max-width: 1279px)').matches) return;
          openItem(item);
        });

        trig.addEventListener('click', function (e) {
          e.preventDefault();
          if (isOpen(item)) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });
      });

      /* Hover-intent close: moving the pointer anywhere in the header
         that is NOT a mega item (plain links, brand, icons, announcement)
         schedules a close; re-entering a mega item cancels it. The 200ms
         grace lets the pointer cross neighbouring links on its way down
         into the open panel without flicker. */
      root.addEventListener('pointerover', function (e) {
        if (window.matchMedia('(max-width: 1279px)').matches) return;
        if (e.target.closest && e.target.closest('[data-mega-item]')) {
          cancelClose();
        } else if (anyOpen()) {
          scheduleClose();
        }
      });

      /* Close on leaving the header entirely */
      root.addEventListener('pointerleave', function () {
        scheduleClose();
      });
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) closeAll(null);
      });

      /* Escape closes open mega and returns focus to its trigger */
      root.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        items.forEach(function (item) {
          if (isOpen(item)) {
            var trig = item.querySelector('[data-mega-trigger]');
            closeItem(item);
            if (trig) trig.focus();
          }
        });
      });

      /* ── Mobile drawer ─────────────────────────────────────── */
      var burger = root.querySelector('[data-drawer-toggle]');
      var drawer = root.querySelector('.gff-drawer');
      var overlay = root.querySelector('.gff-drawer__overlay');
      var closeBtn = root.querySelector('[data-drawer-close]');
      var htmlEl = document.documentElement;
      var lastFocused = null;

      function focusables() {
        if (!drawer) return [];
        return Array.prototype.slice.call(
          drawer.querySelectorAll('a[href], button:not([disabled]), input, summary, [tabindex]:not([tabindex="-1"])')
        ).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      }

      function openDrawer() {
        if (!drawer) return;
        lastFocused = document.activeElement;
        htmlEl.setAttribute('data-drawer-open', '');
        if (burger) burger.setAttribute('aria-expanded', 'true');
        var f = focusables();
        if (f.length) f[0].focus();
      }

      function closeDrawer() {
        htmlEl.removeAttribute('data-drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      }

      if (burger) burger.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      if (overlay) overlay.addEventListener('click', closeDrawer);

      if (drawer) {
        drawer.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { closeDrawer(); return; }
          if (e.key !== 'Tab') return;
          var f = focusables();
          if (!f.length) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault(); last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault(); first.focus();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
